import React from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Check, Sparkles } from 'lucide-react';
import { packages } from '../data/mock';

const Packages = () => {
  const handleInquiry = (packageName) => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Store selected package in session storage for contact form
    sessionStorage.setItem('selectedPackage', packageName);
  };

  return (
    <section id="packages" className="py-20 bg-gradient-to-b from-cream-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="bg-amber-100 text-amber-800 mb-4">
            Best Prices in Rishikesh
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Wedding Packages Designed for Every Dream
          </h2>
          <p className="text-lg text-gray-600">
            Premium quality. Spiritual venues. Unbeatable prices. 
            Choose the celebration that matches your vision.
          </p>
        </div>

        {/* Package Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {packages.map((pkg, index) => (
            <Card
              key={pkg.id}
              className={`relative overflow-hidden transition-all duration-300 hover:shadow-2xl ${
                pkg.popular ? 'border-2 border-amber-500 scale-105 md:scale-110' : 'border border-gray-200'
              }`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="absolute top-4 right-4 z-10">
                  <Badge className="bg-amber-600 text-white">
                    <Sparkles size={14} className="mr-1" />
                    Most Popular
                  </Badge>
                </div>
              )}

              {/* Package Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.name}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <div className="text-sm font-medium mb-1">{pkg.guests}</div>
                  <div className="text-xs opacity-90">{pkg.duration}</div>
                </div>
              </div>

              {/* Package Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {pkg.name}
                </h3>

                {/* Pricing */}
                <div className="mb-6">
                  <div className="flex items-baseline space-x-2 mb-2">
                    <span className="text-3xl font-bold text-amber-700">
                      ₹{pkg.discountedPrice}
                    </span>
                  </div>
                  <Badge variant="outline" className="border-green-500 text-green-700">
                    Best Price in Rishikesh
                  </Badge>
                </div>

                {/* Features */}
                <div className="space-y-3 mb-6">
                  {pkg.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <Check size={18} className="text-amber-600 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <Button
                  className={`w-full ${
                    pkg.popular
                      ? 'bg-amber-600 hover:bg-amber-700'
                      : 'bg-gray-800 hover:bg-gray-900'
                  } text-white`}
                  onClick={() => handleInquiry(pkg.name)}
                >
                  Inquire Now
                </Button>
              </div>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-amber-50 rounded-2xl p-8 max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Need a Custom Package?
          </h3>
          <p className="text-gray-600 mb-6">
            Every wedding is unique. Let's craft a celebration that's perfectly yours.
          </p>
          <Button
            size="lg"
            variant="outline"
            className="border-amber-600 text-amber-700 hover:bg-amber-600 hover:text-white"
            onClick={() => handleInquiry('Custom Package')}
          >
            Request Custom Quote
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Packages;
